import { createSlice } from "@reduxjs/toolkit";
import { paymentInvoiceType } from "../../../types/paymentType";

const initalState: paymentInvoiceType = {
  link: "",
  order_id: "",
  invoice_id: "",
};

const paymentSlice = createSlice({
  name: "invoiceLink",
  initialState: initalState,
  reducers: {
    setInvoiceLink: (state, action) => {
      state.link = action.payload.link;
      state.order_id = action.payload.order_id;
      state.invoice_id = action.payload.invoice_id;
    },
  },
});

export const { setInvoiceLink } = paymentSlice.actions;

export default paymentSlice.reducer;
